<template>
    <form @submit.prevent="handleSearch">
        <div class="inline-form-group">
            <md-field class="search-member">
                <md-input v-model.trim="localSearch" :name="name" :placeholder="placeholder">
                </md-input>
            </md-field>
            <button type="submit" title="Search"
                class="search-addon-btnstyle md-button md-accent card-header md-theme-default search-button">
                <i class="fa fa-search"></i>
            </button>
            <md-button type="button" title="Clear" @click="handleClear"
                class="reset-btn md-button md-accent md-theme-default" :disabled="!localSearch">
                <i class="fa fa-times"></i>
            </md-button>
        </div>
    </form>
</template>

<script>
export default {
    name: 'SearchBar',
    props: {
        value: {type: String, default: ''},
        placeholder: {type: String, default: 'Search...'},
        name: {type: String, default: 'search'}
    },
    data() {
        return {
            localSearch: this.value
        };
    },
    methods: {
        handleSearch() {
            // Update parent's value first
            this.$emit('input', this.localSearch);
            // Then emit the search event with the current value
            this.$emit('search', this.localSearch);
        },
        handleClear() {
            this.localSearch = '';
            this.$emit('clear');
        }
    }
};
</script>

  <style scoped>
  .inline-form-group {
    display: flex;
    align-items: center;
  }
  .inline-form-group md-field {
    flex: 1;
    margin: 0;
  }
  </style>



// WEBPACK FOOTER //
// src/components/SearchBar.vue